import { useParams } from "react-router";
import { isCisOrderNo } from "@shared-core/domain/cis-order-no";
import { PortalCisOrderPage } from "./PortalCisOrderPage";
import { PortalOrderDetailPage } from "./PortalOrderDetailPage";

// `/orders/:orderId` is two pages: a CIS order's number (`ORD-K48193`) opens the CIS order page, anything else
// is a Tharstern job's order ref and opens the order detail page. One address because the card checkout returns
// the customer to `/orders/{order_no}`; the shape alone tells them apart (domain/cis-order-no.ts).
export function PortalOrderRoute() {
  const { orderId = "" } = useParams<{ orderId: string }>();
  return isCisOrderNo(orderId) ? (
    <PortalCisOrderPage />
  ) : (
    <PortalOrderDetailPage />
  );
}
